/**
 * StackedBar — Yatay yığın progress bar
 * StatusRow — Durum satırı (ikon + etiket + değer + yüzde)
 */

export function StackedBar({ segments }) {
    return (
        <div className="h-2.5 bg-neutral-100 dark:bg-neutral-800 rounded-full overflow-hidden flex">
            {segments.map((seg, i) => (
                <div key={i} className={`h-full ${seg.color} transition-all duration-500`} style={{ width: `${seg.pct}%` }} />
            ))}
        </div>
    );
}

export function StatusRow({ icon: Icon, label, value, pct, variant, formatValue }) {
    const colors = {
        success: 'text-success',
        warning: 'text-warning',
        error: 'text-error',
        info: 'text-primary',
        muted: 'text-text-muted',
    };
    return (
        <div className="flex items-center gap-3 py-2">
            <Icon size={14} className={`shrink-0 ${colors[variant]}`} />
            <span className="text-sm text-text-secondary flex-1">{label}</span>
            <span className="font-semibold text-sm text-text-primary">{formatValue(value)}</span>
            <span className="text-xs text-text-muted w-10 text-right">%{pct}</span>
        </div>
    );
}
